import { Routes, Route, Navigate } from "react-router-dom";
import { PermissionGuard } from "@/components/layout/PermissionGuard";
import { ProtectedLayout } from "@/components/layout/ProtectedLayout";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import Appointments from "./pages/Appointments";
import Products from "./pages/Products";
import Conversations from "./pages/Conversations";
import Agents from "./pages/Agents";
import AgentsTest from "./pages/AgentsTest";
import Integrations from "./pages/Integrations";
import Automations from "./pages/Automations";
import Disparos from "./pages/Disparos";
import Settings from "./pages/Settings";
import Deals from "./pages/Deals";
import Tasks from "./pages/Tasks";
import Plans from "./pages/Plans";
import Sobre from "./pages/Sobre";
import Contato from "./pages/Contato";
import SegurancaLgpd from "./pages/SegurancaLgpd";
import WhatsAppAgenteIa from "./pages/comercial/WhatsAppAgenteIa";
import WhatsAppChatbot from "./pages/comercial/WhatsAppChatbot";
import InstagramAutomacaoDm from "./pages/comercial/InstagramAutomacaoDm";
import InstagramAgenteIa from "./pages/comercial/InstagramAgenteIa";
import WhatsAppAtendimentoAutomatico from "./pages/comercial/WhatsAppAtendimentoAutomatico";
import QualificacaoLeadsWhatsApp from "./pages/comercial/QualificacaoLeadsWhatsApp";
import IntegracoesCrm from "./pages/comercial/IntegracoesCrm";
import SetoresImobiliarias from "./pages/comercial/SetoresImobiliarias";
import SetoresClinicas from "./pages/comercial/SetoresClinicas";
import SetoresEducacao from "./pages/comercial/SetoresEducacao";
import SetoresServicos from "./pages/comercial/SetoresServicos";
import GeoFeaturePage from "./pages/comercial/GeoFeaturePage";
import { GEO_FEATURE_PAGES } from "./pages/comercial/geo-feature-pages";
import LlmGeoPage from "./pages/comercial/LlmGeoPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiesPolicy from "./pages/CookiesPolicy";
import NotFound from "./pages/NotFound";
import GoogleCalendarOAuthResult from "./pages/GoogleCalendarOAuthResult";
import InstagramOAuthResult from "./pages/InstagramOAuthResult";
import MessengerOAuthResult from "./pages/MessengerOAuthResult";
import WhatsAppCloudOAuthResult from "./pages/WhatsAppCloudOAuthResult";
import ShopifyOAuthResult from "./pages/ShopifyOAuthResult";
import ShopifyInstall from "./pages/ShopifyInstall";
import OAuthSelectPage from "./pages/OAuthSelectPage";
import GeminiUsage from "./pages/admin/GeminiUsage";
import WhatsAppCloudTemplatesPage from "./pages/integrations/WhatsAppCloudTemplatesPage";
import OAuthConsent from "./pages/OAuthConsent";

/**
 * Rotas síncronas (sem lazy) para o HTML do pré-render coincidir com a hidratação no cliente.
 */
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/planos" element={<Plans />} />
      <Route path="/sobre" element={<Sobre />} />
      <Route path="/about" element={<Sobre canonicalPath="/about" />} />
      <Route path="/contato" element={<Contato />} />
      <Route path="/contact" element={<Contato canonicalPath="/contact" />} />
      <Route path="/desenvolvedores" element={<Navigate to="/contato" replace />} />
      <Route path="/developers" element={<Navigate to="/contato" replace />} />
      <Route path="/seguranca-lgpd" element={<SegurancaLgpd />} />
      <Route path="/whatsapp/agente-ia" element={<WhatsAppAgenteIa />} />
      <Route path="/whatsapp/chatbot" element={<WhatsAppChatbot />} />
      <Route path="/instagram/automacao-dm" element={<InstagramAutomacaoDm />} />
      <Route path="/instagram/agente-ia" element={<InstagramAgenteIa />} />
      <Route path="/whatsapp/atendimento-automatico" element={<WhatsAppAtendimentoAutomatico />} />
      <Route path="/qualificacao-de-leads-no-whatsapp" element={<QualificacaoLeadsWhatsApp />} />
      <Route path="/integracoes/crm" element={<IntegracoesCrm />} />
      <Route path="/setores/imobiliarias" element={<SetoresImobiliarias />} />
      <Route path="/setores/clinicas" element={<SetoresClinicas />} />
      <Route path="/setores/educacao" element={<SetoresEducacao />} />
      <Route path="/setores/servicos" element={<SetoresServicos />} />
      {GEO_FEATURE_PAGES.map((page) => (
        <Route key={page.path} path={page.path} element={<GeoFeaturePage page={page} />} />
      ))}
      <Route path="/llm" element={<LlmGeoPage />} />
      <Route path="/privacidade" element={<PrivacyPolicy />} />
      <Route path="/privacy" element={<PrivacyPolicy canonicalPath="/privacy" />} />
      <Route path="/termos" element={<TermsOfService />} />
      <Route path="/cookies" element={<CookiesPolicy />} />
      <Route path="/oauth/google-calendar" element={<GoogleCalendarOAuthResult />} />
      <Route path="/oauth/instagram" element={<InstagramOAuthResult />} />
      <Route path="/oauth/instagram/select-page" element={<OAuthSelectPage />} />
      <Route path="/oauth/messenger" element={<MessengerOAuthResult />} />
      <Route path="/oauth/whatsapp-cloud" element={<WhatsAppCloudOAuthResult />} />
      <Route path="/oauth/shopify" element={<ShopifyOAuthResult />} />
      <Route path="/integrations/shopify/install" element={<ShopifyInstall />} />
      <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/dashboard" element={<PermissionGuard permission="dashboard"><Dashboard /></PermissionGuard>} />
        <Route path="/leads" element={<PermissionGuard permission="crm"><Leads /></PermissionGuard>} />
        <Route path="/deals" element={<PermissionGuard permission="deals"><Deals /></PermissionGuard>} />
        <Route path="/appointments" element={<PermissionGuard permission="appointments"><Appointments /></PermissionGuard>} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/products" element={<PermissionGuard permission="products"><Products /></PermissionGuard>} />
        <Route path="/conversations" element={<PermissionGuard permission="conversations"><Conversations /></PermissionGuard>} />
        <Route path="/agents" element={<PermissionGuard permission="agents"><Agents /></PermissionGuard>} />
        <Route path="/agents-test" element={<PermissionGuard permission="agents"><AgentsTest /></PermissionGuard>} />
        <Route path="/integrations" element={<PermissionGuard permission="integrations"><Integrations /></PermissionGuard>} />
        <Route path="/integrations/whatsapp-cloud/templates" element={<PermissionGuard permission="integrations"><WhatsAppCloudTemplatesPage /></PermissionGuard>} />
        <Route path="/automations" element={<PermissionGuard permission="automations"><Automations /></PermissionGuard>} />
        <Route path="/disparos" element={<PermissionGuard permission="automations"><Disparos /></PermissionGuard>} />
        <Route path="/settings" element={<PermissionGuard permission="settings"><Settings /></PermissionGuard>} />
        <Route path="/admin/gemini-usage" element={<GeminiUsage />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
